module.exports = __webpack_public_path__ + "img/sync.d1920255.svg";